import React, { useState, useEffect } from "react";
import "./styles.scss";
import Model from "../../../CommonComponents/Model";
import { useLocation } from "react-router-dom";

export default () => {
  const [showModal, setShowModal] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.indexOf("/refer") >= 0) {
      setShowModal(true);
    }
  }, [pathname]);

  const handleActivateModel = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      <div className={"btn-btn-invite-friend"} onClick={handleActivateModel}>
        Invite Friends, Get $5 Each!
      </div>
      <Model show={showModal} handleClose={handleModalClose} title={title} description={desc} />
    </div>
  );
};

let title = "Invite Your Friends, Get $5 for Each One that Registers 🙌";
let desc = (
  <>
    <div className="mt-2">Togetherness is happiness.</div>
    <div className="mt-2">
      Invite up to 5 friends (other artists, bands, MCs, DJs, podcasters, or just good music-loving friends) to join you on UNIFI Music, and we’ll
      give you $5 (USD) for each referred friend who registers, confirms their account, and makes their first post here in the community.
    </div>
    <div className="mt-2">Payments will be made following confirmation of the requirements above to your UNIFI Music account balance.</div>
    <div className="mt-2">
      Once your account balance reaches $20 (USD) total available balance or more, you may withdraw those funds to your PayPal account at any time.
    </div>
    <div className="mt-2">Pretty cool, right?!</div>
  </>
);
